export { ChatPublicPageComponent } from './chat-public-page.component';
export { ChatPublicPageModule } from './chat-public-page.module';
